import { bindActionCreators } from 'redux';
import { connect } from '../../../common/react-redux';
import * as modalActions from '../../../common/actions/modal';
import { generateImportModalId } from '../../../common/components/ImportModal';
import HeaderMenu from './presenter';
function mapStateToProps(state, props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {
    openImportModal: bindActionCreators(modalActions.openModal.bind(modalActions, generateImportModalId('qtiImport')), dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderMenu);